function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.279 10.681l-9.17-9.17.003-.002L10.697.095l-.002.002-.002-.002L9.29 1.499l.001.002L0 10.792l1.414 1.416 9.292-9.293 9.17 9.168z",
  clipRule: "evenodd"
});

var SvgTop = function SvgTop(props) {
  return React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMjEuMzMzcHgiIGhlaWdodD0iMTIuMjA4cHgiIHZpZXdCb3g9IjAgMCAyMS4zMzMgMTIuMjA4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMS4zMzMgMTIuMjA4IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cG9seWdvbiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgcG9pbnRzPSIyMS4yNzksMTAuNjgxIDEyLjEwOSwxLjUxMSAxMi4xMTIsMS41MDkgMTAuNjk3LDAuMDk1IDEwLjY5NSwwLjA5NyANCgkJCTEwLjY5MywwLjA5NSA5LjI5LDEuNDk5IDkuMjkxLDEuNTAxIDAsMTAuNzkyIDEuNDE0LDEyLjIwOCAxMC43MDYsMi45MTUgMTkuODc2LDEyLjA4MyAJCSIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K";
export { SvgTop as ReactComponent };